<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Cart" subtitle="Cart"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- Cart Area Strat-->
  <section class="cart-area pt-100 pb-100">
    <div class="container">
      <div *ngIf="cartService.getCartProducts().length === 0" class="text-center pt-50">
        <h3>No Cart Items Found</h3>
        <a routerLink="/shop" class="os-btn os-btn-black">Continue Shopping</a>
      </div>

      <div *ngIf="cartService.getCartProducts().length > 0" class="row">
        <div class="col-12">
            <div class="table-content table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="product-thumbnail">Images</th>
                    <th class="cart-product-name">Product</th>
                    <th class="product-price">Unit Price</th>
                    <th class="product-quantity">Quantity</th>
                    <th class="product-subtotal">Total</th>
                    <th class="product-remove">Remove</th>
                  </tr>
                </thead>
                <tbody>

                  <tr  *ngFor="let item of cartService.getCartProducts()">
                    <td class="product-thumbnail">
                      <a [routerLink]="['/shop/product', item.id]">
                        <img [src]="(item.product_image)?item.path+item.product_image:'assets/img/dummy/cart-product1.png'" alt="product-{{item.id}}">
                      </a>
                    </td>
                    <td class="product-name">
                      <a [routerLink]="['/shop/product', item.id]">{{item.title}}</a>
                    </td>
                    <td class="product-price"><span class="amount">₹{{item.sale_price.toFixed(2)}}</span></td>
                    <td class="product-quantity">
                      <div class="cart-plus-minus">
                        <input type="text" [value]="item.orderQuantity" readonly />
                        <div (click)="cartService.quantityDecrement(item)" class="dec qtybutton">-</div>
                        <div (click)="cartService.addCartProduct(item)" class="inc qtybutton">+</div>
                      </div>
                    </td>
                    <td class="product-subtotal">
                      <span class="amount">
                      ₹{{(item.sale_price * item.orderQuantity!).toFixed(2)}}
                      </span>
                   </td>
                    <td class="product-remove">
                      <a (click)="cartService.removeCartProduct(item)" class="cursor-pointer">
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
            <!-- <div class="row">
              <div class="col-12">
                <div class="coupon-all">
                  <form (ngSubmit)="handleCouponSubmit()">
                    <div class="coupon">
                      <input id="coupon_code" class="input-text" name="coupon_code" value="" placeholder="Coupon code" type="text">
                      <button class="os-btn os-btn-black" name="apply_coupon" type="submit">
                        Apply coupon
                      </button>
                    </div>
                  </form>
                  <div class="coupon2">
                    <button (click)="cartService.clear_cart()" class="os-btn os-btn-black" name="update_cart" type="submit">
                      Clear cart
                    </button>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row mt-20">
              <div class="col-md-4">
                <div class="">
                  <button (click)="cartService.clear_cart()" class="os-btn os-btn-black" name="update_cart" type="submit">
                    Clear cart
                  </button>
                </div>
              </div>
              <div class="col-md-8 ml-auto">
                <div class="cart-page-total">
                  <h2>Cart totals</h2>
                  <ul class="mb-20">
                    <li>Subtotal <span>₹{{(cartService.totalPriceQuantity().total).toFixed(2)}}</span>
                    </li>
                    <li>Total <span>₹{{(cartService.totalPriceQuantity().total).toFixed(2)}}</span></li>
                  </ul>
                  <a class="os-btn" routerLink="/checkout">Proceed to checkout</a>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Cart Area End-->
</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
